import { useLayoutSettingsStore } from '@/stores/layoutSettingsStore';
import { useLocaleStore } from '@/stores/localeStore';

export function formatAccountTime(value: string, locale: string, timeZone: string) {
  return new Intl.DateTimeFormat(locale, {
    timeZone,
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(new Date(value));
}
export function AccountTime({ value }: { value: string }) {
  const locale = useLocaleStore((state) => state.locale);
  const timeZone = useLayoutSettingsStore(
    (state) => state.settings.timeZone ?? 'Asia/Shanghai',
  );
  return (
    <time dateTime={value} title={timeZone}>
      {formatAccountTime(value, locale, timeZone)}
    </time>
  );
}
